import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DoctorSocialService } from '../doctor-social.service';
import { AppService } from 'src/app/app.service';

@Component({
  selector: 'app-likes-list-dialog',
  templateUrl: './likes-list-dialog.component.html',
  styleUrls: ['./likes-list-dialog.component.css']
})
export class LikesListDialogComponent implements OnInit {

  Likes;
  showDialog : boolean = false

  constructor(
    public dialogRef: MatDialogRef<LikesListDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private service: DoctorSocialService,
    public app: AppService
  ) { }

  ngOnInit(): void {
    if(this?.data?.type == 'post'){
      this.getPostLikes();
    }else {
      this.getCommentLikes();
    }
  }

  getPostLikes() {
    this.service.getPostLikes(this?.data?.id, 999, 1).subscribe(
      res => {
        this.Likes = res?.data?.data
        this.showDialog = true
      }
      )
    }
    
    getCommentLikes(){
      this.service.getCommentsLikes(this?.data?.id, 999, 1).subscribe(
        res => {
          this.Likes = res?.data?.data
          this.showDialog = true
      }
    )
  }

  cancel(){
    this.dialogRef.close(null);
  }

}
